import { OfferFragment } from '@occc/graphql';
import { makeCreateOrderAheadOnlyConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { Operation } from '@occc-app/offerHelpers/types';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

import { OrderAheadOnlyFormValues } from './order-ahead-only-constraint.types';

import { getPresenceConstraintOperations } from '../presence-constraint';

export const getOrderAheadOnlyConstraint = (offer: OfferFragment | undefined) => {
  return offer?.constraints.find(constraintHelper.isOrderAheadOnly);
};

export const getOrderAheadOnlyInitialValues = (
  offer: OfferFragment,
): OrderAheadOnlyFormValues['orderAheadOnlyConstraint'] => {
  return {
    isEnabled: !!getOrderAheadOnlyConstraint(offer),
  };
};

export const getOrderAheadOnlyConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  shouldBeEnabled: boolean,
): Operation[] => {
  return getPresenceConstraintOperations(
    offerId,
    getOrderAheadOnlyConstraint(offer),
    shouldBeEnabled,
    makeCreateOrderAheadOnlyConstraintOperation,
  );
};
